import { useState, useEffect, useMemo } from "react";
import { useInvoice } from "../../stores/useInvoice";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement,
  LineController,
  BarController,
} from "chart.js";
import { Bar, Chart } from "react-chartjs-2";
import { useTheme } from "@mui/material";
import { StyledDashboardBarChart } from "../dashBoardBarChart/dashBoardBarChart.styled";
import { Project } from "../../models/Project";
import { formatDateToYYYYMM } from "../../globals/utils";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

type DashBoardBarChartProps = {
  top10Income: (Project & { totalIncome: number })[]
};

type ChartProps = {
  top10Income: {project: Project, totalIncome: number}[]
};

export const HighestIncomeChart = ({ top10Income }: DashBoardBarChartProps) => {
  const theme = useTheme();

 const options = {
  responsive: true,
  indexAxis: "y" as const,       // <-- works
  scales: {
    x: {
      beginAtZero: true
    }
  }
};

  // Filter invalid items once
  const cleanTop10 = useMemo(
    () =>
      top10Income.filter(
        (income) => income && income.creationDate && income.code
      ),
    [top10Income]
  );

  const labels = useMemo(
    () =>
      cleanTop10.map((income) =>
        `PRO-${formatDateToYYYYMM(new Date(income.creationDate))}-${income.code}`
      ),
    [cleanTop10]
  );

  const datasets = useMemo(
    () => [
      {
        type: "bar" as const,
        label: "Winst voor belastingen",
        data: cleanTop10.map((income) => income.totalIncome),
        backgroundColor: theme.palette.success.main,
        order: 1,
      },
    ],
    [cleanTop10, theme.palette.success.main]
  );

  const data = useMemo(() => {
    if (!labels.length) return null;
    return { labels, datasets };
  }, [labels, datasets]);

  return (
    <StyledDashboardBarChart>
      {data ? (
        <Chart type="bar" options={options} data={data} />
      ) : (
        <p>Loading chart...</p>
      )}
    </StyledDashboardBarChart>
  );
};
